module.exports = __webpack_public_path__ + "img/athena-solutions.f68b5ee2.png";